import { User, isAdmin, isStaff, isGuestOnly, isFamilyUser } from '../types/auth';
import { ClubSettings } from '../types/clubSettings';
import { HelpAudience, HelpModule } from './types';
import { Feature } from './features';
import { helpModules } from './modules';

/** Ki van-e kapcsolva a modul a klubnál - akkor a menüben sincs, a súgóban se legyen. */
const isModuleEnabled = (moduleId: string, settings?: ClubSettings | null) =>
  moduleId !== 'membership-fees' || settings?.membershipFeesEnabled === true;

const hasAudience = (user: User | null, audience: HelpAudience) => {
  if (audience === 'admin') return isAdmin(user);
  if (audience === 'staff') return isStaff(user);
  return true;
};

/**
 * Láthatja-e a felhasználó a modul súgóját. Ugyanazt a szűkítést követi, mint a
 * menü: a szülő ne olvasson olyan funkcióról, amit nem is ér el.
 */
export const canSeeHelp = (user: User | null, module: HelpModule, settings?: ClubSettings | null) => {
  if (settings !== undefined && !isModuleEnabled(module.id, settings)) return false;
  if (isGuestOnly(user)) return module.forGuests === true;
  if (isFamilyUser(user)) return module.forFamily === true;
  return hasAudience(user, module.audience);
};

/** Láthatja-e a funkciót: a modulja látható neki, és ha a funkció szűkebb körnek szól, abba is beletartozik. */
export const canSeeFeature = (user: User | null, feature: Feature, settings?: ClubSettings | null) => {
  const module = helpModules.find((m) => m.id === feature.module);
  if (!module || !canSeeHelp(user, module, settings)) return false;
  if (!feature.audience) return true;
  // A vendég csak a modul szintjén kap hozzáférést; egy szűkített funkció nem neki szól
  return !isGuestOnly(user) && hasAudience(user, feature.audience);
};
